jQuery(document).ready(function ($) {

  var loader  = $('.jc-loader'),
      videos  = $(".jc-videos"),
      page    = 1,
      pages   = videos.data('pages');


  loader.addClass('d-none');

  window.addEventListener('scroll', function () {

    if (loader[0].classList.contains('d-none') && pages > page && isBottomVisible()) {
      loader.removeClass('d-none');
      page++;
      getVideos();
    }

  });

  function getVideos() {
    $.ajax({
      url: videosHandler.url,
      type: 'GET',
      data: {
        action: 'jc_ajax_retrive_videos_template',
        page: page,
      },
      success: function success(response) {
        if (response && response.success) {
          videos.append(response.data.template);
          loader.addClass('d-none');
        }
      },
    });
  }

  function isBottomVisible() {
    var visible = document.documentElement.clientHeight;
    var pageHeight = document.documentElement.scrollHeight - $('footer')[0].offsetHeight;
    return (visible + window.scrollY >= pageHeight);
  }
});
